<template>
    <div :class="classes">
    </div>
</template>

<script>

    export default {
        props: {
            up: {
                required: false,
                default: false
            }
        },
        computed: {
            classes() {
                return 'divider ' + (this.up ? 'up' : 'down');
            }
        }
    }
</script>

<style>
    .divider {
        height: 30px;
        background-repeat: repeat-x;
    }
    .up {
        background-image: url("../assets/shadow_up.jpg");
    }
    .down {
        background-image: url("../assets/shadow_down.jpg");
    }
</style>